<template>
  <!-- 再登録画面 -->
  <div class="mypage">
    <header class="header">
      <img src="../assets/omi-logo.svg" />
    </header>
    <div
      class="setion01"
      style="height: 60px; background-color: rgba(8, 110, 182, 0.04)"
    >
      <p style="margin: 0; padding-top: 18px">退会済</p>
    </div>
    <div style="padding-bottom: 300px">
      <div class="section02">
        <p>再度ご利用になる場合は新規登録が必要です</p>
      </div>
      <common-button
        :data="{
          status: 0,
          button: '再登録に進む',
        }"
        @click="onDialogAction()"
      ></common-button>
    </div>
  </div>
  <RegistModal v-model="showModal" />
</template>

<script setup lang="ts">
import { ref } from "vue";

const showModal = ref(false);
import CommonButton from "./CommonButton.vue";
import RegistModal from "./RegistModal.vue";

function onDialogAction() {
  showModal.value = true;
}
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";
.mypage {
  // overflow: hidden;
  @include container();
}
@mixin buttons($value) {
  background: $value;
  position: relative;
  align-items: center;
  // max-width: 350px;
  height: 56px;
  margin: 0 auto;
  border-radius: 1px;

  width: 327px;
  padding: 0 8px;
  p:nth-child(1) {
    font-size: $FONT_SIZE_XS;
    padding: 7px 0 0 0;
    margin: 0;
  }
  p:nth-child(2) {
    font-size: $FONT_SIZE_L;
    padding: 0;
    margin: 0;
  }
  p {
    color: $white;
    line-height: 21px;
    text-decoration: none;
    font-weight: 500;
  }
}
.header {
  text-align: center;
  width: 100%;
}
.setion01 {
  margin-top: 40px;
  text-align: center;

  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
}
.section02 {
  padding-top: 53px;
  padding-bottom: 32px;
  text-align: center;
  p:nth-child(1) {
    font-style: normal;
    font-weight: 590;
    font-size: 15px;
    line-height: 220%;
    /* ボックスの高さと同一、または33px */
    text-align: center;
    color: #333333;
  }
  p:nth-child(n + 2) {
    width: 330px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 24px;
    margin: auto;
    padding-bottom: 8px;
    color: #333333;
  }
}
.section03 {
  text-align: center;
  padding-bottom: 23px;
  p {
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;
    margin: auto;
    color: #086eb6;
    padding-bottom: 5px;
  }
}

.section04 {
  padding-top: 53px;
  p {
    width: 300px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_M;
    line-height: 21px;
    margin: auto;
  }
}

.mypage__list {
  width: 315px;
  margin: 0 auto;
}
.list__item {
  width: 100%;
  height: 50px;
  background-color: $white;
  padding-left: 23px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  label {
    width: calc(100% - 65px);
  }
  img {
    text-align: right;
    filter: invert(13%) sepia(0%) saturate(2293%) hue-rotate(317deg)
      brightness(83%) contrast(77%);
    padding-right: 20px;
  }
  label {
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_S;
    line-height: 18px;

    color: #333333;
  }
}

.list__item:nth-child(1) {
  border-top: 1px solid #d9d9d9;
}
.account_name {
  position: absolute;
  height: 32px;
  left: 20px;
  top: 61px;
}
.detail {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f3f4f5;
}
.footer {
  @include footer-button(480px);
}
.active {
  @include buttons($OMOT_COLOR);
}
.inactive {
  @include buttons(grey);
  border: 1px solid grey;
}

input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #086eb6;
  background-color: #ffffff;
  border-radius: 2px;
}
input[type="checkbox"]::before {
  content: url("../assets/checkbox.svg");
  visibility: hidden;
  background-color: #ffffff;
  vertical-align: middle;
  border: 1px solid #086eb6;
}
input[type="checkbox"]:checked::before {
  visibility: visible;
  background-color: #086eb6;
  border: 1px solid #086eb6;
}
</style>
